import { useQuery } from '@tanstack/react-query';

import { getProductMedia, toProductGalleryItems, type GtinMediaParams } from '../media.api';

/**
 * Queries the customer's own product media (tenant-scoped) and exposes mapped gallery
 * items plus a degraded flag. Mediaserver outage degrades only this query (NFR4): the
 * product-media page shows an info card while the product list keeps working.
 */
export function useProductMedia(params: GtinMediaParams, enabled = true) {
  const { gln, gtin, targetMarket = '528' } = params;
  const query = useQuery({
    queryKey: ['media', 'product', gln, gtin, targetMarket],
    queryFn: () => getProductMedia(params),
    enabled: enabled && !!gln && !!gtin,
    staleTime: 5 * 60 * 1000,
  });

  const result = query.data;
  const items = result?.data == null ? [] : toProductGalleryItems(result.data);
  const degraded = result?.meta.degraded ?? false;

  return { ...query, items, degraded };
}
